import React from 'react'
import { EmptyState as UiEmptyState, Button } from '../ui'

/**
 * Back-compat wrapper for the historical "Ready for your next 1:1?" hero.
 * Renders the new <EmptyState> primitive with the session-specific copy.
 *
 * Existing call sites still import `{ EmptyState }` from this path; new
 * code should import the primitive directly from `../ui`.
 */
export function EmptyState({ onCreateSession }) {
  return (
    <UiEmptyState
      data-testid="empty-state"
      icon={<img src="/logo-mark.svg" alt="" width={52} height={52} />}
      title="Ready for your next 1:1?"
      body="Capture your wins, challenges, and priorities before you meet."
      action={
        <Button size="lg" onClick={onCreateSession}>
          Start your first prep
        </Button>
      }
      footer={
        <p style={{ fontSize: 12, color: 'var(--text-secondary)', marginTop: 8 }}>
          Prepare. Align. Grow.
        </p>
      }
    />
  )
}
